import Gravity from 'gravityglobal-parent/assets/js/global-functions';

const filpCardsModule = () => {
  document.querySelectorAll('.gg-flip-card__back-description').forEach((card) => {
    const { offsetHeight, scrollHeight } = card;

    if (offsetHeight < scrollHeight) {
      card.setAttribute('tabindex', 0);
    }
  });
};

Gravity.ready(filpCardsModule);
